import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import { propTypes as picturePropTypes } from '../../../01_atoms/DefaultPicture';
import { behaviorSettingsProps } from '../../../../utils/behaviorSettings';

const PTBBCarousel = {
  items: arrayOf(
    shape({
      description: string.isRequired,
      image: shape(picturePropTypes).isRequired,
      title: string,
      nextLabel: string,
      cta: shape({
        label: string.isRequired,
        nextLink: shape(linkPropTypes).isRequired,
      }),
    }),
  ),
  behaviorSettings: behaviorSettingsProps,
  uuid: string,
};

const PTBBCarouseSliderSettings = {
  sliderSettings: shape({
    dots: bool,
    infinite: bool,
    speed: number,
    slidesToScroll: number,
    beforeChange: func,
    afterChange: func,
  }),
};

export { PTBBCarousel, PTBBCarouseSliderSettings };
